import { Box, Slider, Tooltip, Typography } from "@mui/material";
import { MasteringPresets, targets } from "./types";
import { ChoosePresetProps, MasteringPresetObj } from "./types";
import { useEffect, useState } from "react";
import { PresetImageContainer, styles } from "./styles";
import { PresetSuggestionContainer } from "./styles";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { APP_COLOR, TEXT_COLOR } from "../../theme";

export const ChoosePreset: React.FC<ChoosePresetProps> = ({
  setSelectedPresetArray,
  selectedPresetArray,
  sliderValue,
  setSliderValue,
  setLoading,
  handleAccessStage,
}) => {
  const [tabIndex, setTabIndex] = useState(2);

  const handleSliderChange = (value: any) => {
    setLoading(true);
    setSliderValue(value.target.value);
    setTabIndex(-1);
  };
  const handleTabsChange = (index: number) => {
    setLoading(true);
    setTabIndex(index);
    setSliderValue(targets[index].loudness);
  };

  const handleSelectedPresetValue = (value: MasteringPresetObj) => {
    setLoading(true);
    if (
      selectedPresetArray.length < 5 &&
      !selectedPresetArray.includes(value.value)
    ) {
      setSelectedPresetArray([...selectedPresetArray, value.value]);
    } else if (selectedPresetArray.includes(value.value)) {
      setSelectedPresetArray(
        selectedPresetArray.filter((el) => el !== value.value)
      );
    }
  };

  useEffect(() => {
    handleAccessStage(2);
  }, [handleAccessStage]);

  return (
    <>
      <Typography sx={{ color: TEXT_COLOR }} variant="h6">
        Style
      </Typography>
      <Typography sx={{ color: TEXT_COLOR }}>Choose up to 5 presets</Typography>
      <Box sx={styles.presetsContainer}>
        {MasteringPresets.map((el) => {
          return (
            <Tooltip title={el.description} key={el.title}>
              <Box
                onClick={() => handleSelectedPresetValue(el)}
                sx={{
                  ...styles.presetBox,
                  ...{
                    backgroundColor:
                      selectedPresetArray.includes(el.value) && APP_COLOR,
                  },
                }}
                key={el.title}
              >
                <Typography sx={{}} variant="subtitle1">
                  {el.title}
                </Typography>
                <PresetImageContainer>
                  <img
                    height={20}
                    width="auto"
                    src={`/assets/svg/${el.title.toLowerCase()}.svg`}
                    alt=""
                  />
                </PresetImageContainer>
                <PresetSuggestionContainer variant="caption">
                  {el.suggestedUse.join(", ")}
                </PresetSuggestionContainer>
              </Box>
            </Tooltip>
          );
        })}
      </Box>

      <Typography sx={{ marginTop: "15px", color: TEXT_COLOR }} variant="h6">
        Loudness (LUFS)
        <Tooltip
          sx={{ marginLeft: "5px" }}
          title="The loudness parameter controls the target loudness in LUFS (Loudness Units relative to Full Scale). The default is a target level of -14 LUFS, and the level can be adjusted to meet a streaming provider's requirements. Check out the recommended target loudness for each streaming provider in the list below or set your own."
        >
          <HelpOutlineIcon color="info" style={{ height: 20, width: 20 }} />
        </Tooltip>
      </Typography>

      <Box
        sx={{ display: "flex", gap: "15px", margin: "20px", flexWrap: "wrap" }}
      >
        {targets.map((el, i) => {
          return (
            <Box
              onClick={() => handleTabsChange(i)}
              key={el.text}
              sx={{
                ...styles.targetBox,
                ...{
                  backgroundColor: tabIndex === i ? APP_COLOR : "",
                },
              }}
            >
              {el.text}
            </Box>
          );
        })}
      </Box>
      <Box sx={{ display: "flex" }}>
        <Slider
          sx={{ width: "30%", margin: "0 0 0 20px" }}
          aria-label="Temperature"
          min={-48}
          max={0}
          step={1}
          defaultValue={sliderValue}
          value={sliderValue}
          onChange={handleSliderChange}
          color="primary"
        />
        <Typography
          sx={{ paddingLeft: "10px", fontSize: "17px", color: TEXT_COLOR }}
        >
          {sliderValue}
        </Typography>
      </Box>
    </>
  );
};
